(function () {
  'use strict';

  var DEFAULT_ANIMATION_TIME = 350;
  var SLIDER_ANIMATION_TIME = 700;
  // Mark any animation with CSS class during animation to support better testing results
  var ANIMATED_CLASS = 'animated';

  var fps = 60;
  var requestAnimationFrameFallback = function (cb) { return setTimeout(cb, 1000 / fps); };
  function requestAnimationFrame$1(cb) {
      var nextAnimationFrame = window.requestAnimationFrame || requestAnimationFrameFallback;
      nextAnimationFrame(cb);
  }
  function animationFrame(duration, onFrame, complete) {
      var start = Date.now();
      var nextAnimationFrame = window.requestAnimationFrame || requestAnimationFrameFallback;
      var nextFrame = function () {
          var tx = Math.min(duration, Date.now() - start);
          var percent = tx / duration;
          onFrame(percent);
          if (tx < duration) {
              nextAnimationFrame(nextFrame);
          }
          else if (!!complete) {
              complete();
          }
      };
      nextFrame();
  }

  /*
   * It is not possible to animate an auto height value with CSS a transitions needs an exact height value.
   *
   * These helper functions set the correct height value to the element that an animation works with the height.
   *
   */
  var ANIMATION_COLLAPSING_CLASS_NAME = 'animation-collapsing';
  var ANIMATION_COLLAPSED_CLASS_NAME = 'animation-collapsed';
  var ANIMATION_EXPANDING_CLASS_NAME = 'animation-expanding';
  var ANIMATION_EXPANDED_CLASS_NAME = 'animation-expanded';
  function collapse(target) {
      // apply the current height and the reset for the animation
      animationHeightHelper(target, true);
      // With the next animation frame set the height to 0px so that the animation could
      // start for a collapsing. Because of an strange behavior with Firefox whe have
      // to wait two frames
      requestAnimationFrame$1(function () {
          requestAnimationFrame$1(function () {
              target.style.height = '0px';
          });
      });
  }
  function expand(target) {
      // apply the current height and the reset for the animation
      animationHeightHelper(target);
  }
  function animationHeightHelper(target, collapsing) {
      if (collapsing === void 0) { collapsing = false; }
      target.classList.remove(ANIMATION_COLLAPSED_CLASS_NAME);
      target.classList.remove(ANIMATION_EXPANDED_CLASS_NAME);
      if (collapsing) {
          target.classList.add(ANIMATION_COLLAPSING_CLASS_NAME);
      }
      else {
          target.classList.add(ANIMATION_EXPANDING_CLASS_NAME);
      }
      var onTransitionStart = function () {
          target.removeEventListener('transitionstart', onTransitionStart);
          target.classList.add(ANIMATED_CLASS);
      };
      // reset the applied height value when the transition ends to ensure that
      // the height value from the CSS wins
      var onTransitionEnd = function () {
          target.removeEventListener('transitionend', onTransitionEnd);
          target.classList.remove(ANIMATED_CLASS);
          if (collapsing) {
              target.classList.remove(ANIMATION_COLLAPSING_CLASS_NAME);
              target.classList.add(ANIMATION_COLLAPSED_CLASS_NAME);
          }
          else {
              target.classList.remove(ANIMATION_EXPANDING_CLASS_NAME);
              target.classList.add(ANIMATION_EXPANDED_CLASS_NAME);
          }
          delete target.style.height;
      };
      target.addEventListener('transitionstart', onTransitionStart);
      target.addEventListener('transitionend', onTransitionEnd);
      // apply the real size for the animation
      target.style.height = target.scrollHeight + "px";
  }

  var className = 'accordion--open';
  $.fn.toggleAccordion = function () {
      return this.each(function (_, item) {
          var $accordion = $(item);
          var $toggle = $accordion.find('.accordion__toggle');
          var $content = $accordion.find('.accordion__content');
          if ($toggle.length && $content.length) {
              if ($accordion.hasClass(className)) {
                  collapse($content.get(0));
              }
              else {
                  expand($content.get(0));
              }
              $accordion.toggleClass(className);
          }
          return true;
      });
  };
  $.fn.accordion = function () {
      return this.each(function (_, item) {
          var $accordion = $(item);
          var $toggle = $accordion.find('.accordion__toggle');
          var $content = $accordion.find('.accordion__content');
          $toggle.on('click', function (ev) {
              var $target = $(ev.target);
              // delay the action for nested elements which needs to clean up before the
              // accordion animation like the tooltip
              requestAnimationFrame$1(function () {
                  $target
                      .parents('[data-accordion]')
                      .toggleAccordion();
              });
              return true;
          });
          // add collapsed class to fix initial visible scrollbar
          var isOpen = $accordion.hasClass(className);
          $content.addClass(isOpen ? 'animation-expanded' : 'animation-collapsed');
          return true;
      });
  };

  // Add CSS class while animation is in process
  $.fn.animated = function () {
      return this.each(function (_, item) {
          var $item = $(item);
          $item.on('transitionstart', function () {
              $item.addClass(ANIMATED_CLASS);
              $item.one('transitionend', function () {
                  $item.removeClass(ANIMATED_CLASS);
                  return true;
              });
              return true;
          });
          return true;
      });
  };

  function isCollapsed($collapsible) {
      var className = $collapsible.attr('data-collapsible');
      return !$collapsible.hasClass(className);
  }
  $.fn.toggleCollapsible = function () {
      return this.each(function (_, item) {
          var attributeName = 'data-collapsible';
          var $collapsible = $(item);
          var className = $collapsible.attr(attributeName);
          var $toggle = $collapsible.find("[" + attributeName + "-toggle]");
          var $content = $collapsible.find("[" + attributeName + "-content]");
          var $arrow = $collapsible.find('.arrow');
          if ($toggle.length && $content.length) {
              $content.addClass(ANIMATION_COLLAPSED_CLASS_NAME);
              if ($collapsible.hasClass(className)) {
                  collapse($content.get(0));
              }
              else {
                  expand($content.get(0));
              }
              $collapsible.toggleClass(className);
              if ($arrow) {
                  if ($collapsible.hasClass(className)) {
                      $arrow.removeClass('arrow--down');
                      $arrow.addClass('arrow--up');
                  }
                  else {
                      $arrow.removeClass('arrow--up');
                      $arrow.addClass('arrow--down');
                  }
              }
          }
          return true;
      });
  };
  $.fn.expand = function () {
      return this.each(function (_, item) {
          var $collapsible = $(item);
          if (isCollapsed($collapsible)) {
              $collapsible.on('transitionend', function () {
                  $collapsible.off('transitionend').trigger('expand:end');
                  return true;
              })
                  .toggleCollapsible();
          }
          else {
              $collapsible.trigger('expand:end');
          }
          return true;
      });
  };
  $.fn.collapse = function () {
      return this.each(function (_, item) {
          var $collapsible = $(item);
          if (!isCollapsed($collapsible)) {
              $collapsible.toggleCollapsible();
          }
          return true;
      });
  };
  $.fn.collapsible = function () {
      return this.each(function (_, item) {
          var $collapsible = $(item);
          var $toggle = $collapsible.find('[data-collapsible-toggle]');
          $toggle.on('click', function (ev) {
              $(ev.target)
                  .parents('[data-collapsible]')
                  .toggleCollapsible();
              return true;
          });
          // add collapsed class to fix initial visible scrollbar
          $collapsible.find('[data-collapsible-content]').addClass('animation-collapsed');
          return true;
      });
  };

  // credits to https://css-tricks.com/emulating-css-timing-functions-javascript/#timing-fn-comparison
  var easeOut = function (value) { return 1 - Math.pow(1 - value, 1.675); };

  $.fn.resizeHeight = function (height, duration, onProcess, onEnd) {
      return this.each(function (_, item) {
          var $item = $(item);
          var origHeight = $item.height();
          var deltaHeight = height - origHeight;
          $item.addClass(ANIMATED_CLASS);
          animationFrame(duration, function (percent) {
              $item.height(origHeight + deltaHeight * easeOut(percent));
              if (onProcess) {
                  onProcess();
              }
          }, function () {
              $item.removeClass(ANIMATED_CLASS);
              if (onEnd) {
                  onEnd();
              }
          });
          return true;
      });
  };

  /**
   * Implement touch events swipeLeft and swipeRight on given elements
   *
   * Usage: `$('container').touch().on('swipeLeft', () => console.log('swipe left'))`
   */
  $.fn.touch = function () {
      return this.each(function (_, item) {
          var $item = $(item);
          var touchStart = false;
          $item.on('touchstart', function (e) {
              var touch = e.changedTouches[0];
              touchStart = { pageX: touch.pageX, pageY: touch.pageY };
          }).on('touchend', function (e) {
              var touch = e.changedTouches[0];
              if (!touchStart) {
                  return true;
              }
              var diffX = touch.pageX - touchStart.pageX;
              // Invert horizontal diff which are count from top (0) to bottom (max)
              var diffY = touchStart.pageY - touch.pageY;
              touchStart = false;
              var distance = Math.sqrt(diffX * diffX + diffY * diffY);
              var isShortSwipe = distance < 20;
              if (isShortSwipe) {
                  return true;
              }
              var angle = (360 + Math.atan2(diffY, diffX) * 180 / Math.PI) % 360;
              // use 60 degrees angle as direction indicator
              var isSwipeLeft = (angle + 180 + 30) % 360 < 60;
              var isSwipeRight = (angle + 30) % 360 < 60;
              if (isSwipeLeft) {
                  $item.trigger('swipeLeft', [e]);
              }
              else if (isSwipeRight) {
                  $item.trigger('swipeRight', [e]);
              }
              return true;
          });
          return true;
      });
  };

  function init() {
      $('[data-accordion]').accordion();
  }

  var accordion = /*#__PURE__*/Object.freeze({
    init: init
  });

  /**
   * Intercep checkbox click due composition of checkbox within a collapsible.
   * The click event prevents bubbleling. Otherwise the checkbox click would
   * also trigger the collapsible.
   */
  function init$1() {
      registerCheckbox();
  }
  function registerCheckbox() {
      $('.checkbox').click(function (e) {
          var $checkbox = $(e.currentTarget).find('.checkbox__input');
          // Each label triggers a click event for the checkbox.
          // The timeout fixes click events for multiple labels. See https://jsfiddle.net/kg8r92yn/
          setTimeout(function () {
              var isChecked = $checkbox.prop('checked');
              $checkbox.prop('checked', !isChecked);
          }, 0);
          return false;
      });
  }

  var checkbox = /*#__PURE__*/Object.freeze({
    init: init$1
  });

  function init$2() {
      $('[data-collapsible]').collapsible();
  }

  var collapsible = /*#__PURE__*/Object.freeze({
    init: init$2
  });

  function init$3() {
      registerDetailsInitiators();
  }
  function registerDetailsInitiators() {
      var attributeName = 'data-details';
      var $initiators = $("[" + attributeName + "]");
      return $initiators.each(function (index, item) {
          var $details = $(item);
          var id = $details.attr(attributeName);
          var className = $details.attr(attributeName + "-toggle");
          var $button = $("[" + attributeName + "-button=\"" + id + "\"]");
          if (className && $button.length) {
              var $moreText_1 = $button.find("[" + attributeName + "-more-text]");
              var $lessText_1 = $button.find("[" + attributeName + "-less-text]");
              if ($moreText_1.length && $lessText_1.length) {
                  $details.addClass(ANIMATION_COLLAPSED_CLASS_NAME);
                  $button.on('click', function () {
                      if ($details.hasClass(className)) {
                          collapse($details.get(0));
                      }
                      else {
                          expand($details.get(0));
                      }
                      $details.toggleClass(className);
                      if ($details.hasClass(className)) {
                          $moreText_1.hide();
                          $lessText_1.show();
                      }
                      else {
                          $moreText_1.show();
                          $lessText_1.hide();
                      }
                      return true;
                  });
              }
          }
          return true;
      });
  }

  var details = /*#__PURE__*/Object.freeze({
    init: init$3
  });

  var throttle = function (fn, delay) {
      var timerId;
      return function () {
          if (!timerId) {
              timerId = setTimeout(function () {
                  timerId = undefined;
                  fn();
              }, delay);
          }
          return true;
      };
  };

  var DIALOG_VISIBLE_CLASS = 'dialog--visible';
  var ESCAPE_KEY = 27;
  function init$4() {
      registerDialogInitiators('open');
      registerDialogInitiators('close');
      registerDialogInitiators('instant');
      registerEscHandler();
  }
  function registerDialogInitiators(actionKey) {
      var attributeName = "data-" + actionKey + "-dialog";
      var $initiators = $("[" + attributeName + "]");
      $initiators.each(function (_, item) {
          var $opener = $(item);
          var dialogId = $opener.attr(attributeName);
          var $dialog = $("#" + dialogId);
          if (!$dialog.length) {
              return true;
          }
          if (actionKey === 'instant') {
              openDialog($dialog);
          }
          else {
              $opener.on('click', function (evt) {
                  if (actionKey === 'open') {
                      openDialog($dialog);
                  }
                  else if (actionKey === 'close') {
                      closeDialog($dialog);
                  }
                  var stopPropagation = $opener.is("[" + attributeName + "-stop-propagation]");
                  return !stopPropagation;
              });
          }
          return true;
      });
  }
  function registerEscHandler() {
      $(document).on('keydown', function (ev) {
          if (ev.keyCode === ESCAPE_KEY) {
              var $dialog = $("." + DIALOG_VISIBLE_CLASS);
              if ($dialog.length) {
                  closeDialog($dialog);
              }
          }
          return true;
      });
  }
  // ULIINT-8210 Fix hidden buttons for mobile webkit
  var lastInnerHeight = 0;
  function setMaxHeight() {
      var innerHeight = window.innerHeight;
      if (lastInnerHeight !== innerHeight) {
          $("." + DIALOG_VISIBLE_CLASS + " .dialog__overlay").css('maxHeight', innerHeight);
          lastInnerHeight = innerHeight;
      }
  }
  var setMaxHeightThrottled = throttle(setMaxHeight, 100);
  function openDialog($dialog) {
      $dialog.addClass(DIALOG_VISIBLE_CLASS);
      $('body').css('overflowY', 'hidden');
      setMaxHeight();
      $(window).on('resize', setMaxHeightThrottled);
  }
  function closeDialog($dialog) {
      $dialog.removeClass(DIALOG_VISIBLE_CLASS);
      $('body').css('overflowY', '');
      $(window).off('resize', setMaxHeightThrottled);
  }

  var dialog = /*#__PURE__*/Object.freeze({
    init: init$4
  });

  var INFO_BOX_OPEN_CLASS_NAME = 'info-box--open';
  function init$5() {
      registerInfoBoxInitiators('toggle');
      registerInfoBoxInitiators('close');
  }
  function registerInfoBoxInitiators(actionKey) {
      var attributeName = "data-" + actionKey + "-info-box";
      var $initiators = $("[" + attributeName + "]");
      $initiators.each(function (index, item) {
          var $opener = $(item);
          var infoBoxName = $opener.attr(attributeName);
          var $infoBox = $("[data-info-box=\"" + infoBoxName + "\"]");
          if ($infoBox.length) {
              $infoBox.addClass(ANIMATION_COLLAPSED_CLASS_NAME);
              $opener.on('click', function (evt) {
                  if (actionKey === 'toggle') {
                      if ($infoBox.hasClass(INFO_BOX_OPEN_CLASS_NAME)) {
                          collapse($infoBox.get(0));
                      }
                      else {
                          expand($infoBox.get(0));
                      }
                      $infoBox.toggleClass(INFO_BOX_OPEN_CLASS_NAME);
                  }
                  else if (actionKey === 'close') {
                      collapse($infoBox.get(0));
                      $infoBox.removeClass(INFO_BOX_OPEN_CLASS_NAME);
                  }
                  return true;
              });
          }
          return true;
      });
  }

  var infoBox = /*#__PURE__*/Object.freeze({
    init: init$5
  });

  function init$6() {
      var $browserWarnings = $('.invalid-browser');
      $browserWarnings.each(function (_, item) {
          var $browserWarning = $(item);
          var $closeButton = $browserWarning.find('.invalid-browser__close-button');
          $closeButton.on('click', function () {
              $browserWarning.removeClass('invalid-browser--visible');
              $browserWarning.addClass('invalid-browser--hidden');
          });
          return true;
      });
  }

  var invalidBrowser = /*#__PURE__*/Object.freeze({
    init: init$6
  });

  var dictionaryLoaded = false;
  var loadDictionary = function () {
      if (dictionaryLoaded || !zxcvbnDictionary) {
          return;
      }
      zxcvbn.attachUserDictionary(zxcvbnDictionary);
      dictionaryLoaded = true;
  };
  // zcxvbn's score is 0 - 4, while 4 is the strongest value. We use perCent as score
  var zxcvbnScoreToPerCent = function (score) { return score * 25; };
  var PASSWORD_MIN_LENGTH = 8;
  var PASSWORD_MIN_ACCEPTABLE_SCORE = 50;
  var PASSWORD_MIN_STRONG_SCORE = 75;
  function calculatePasswordStrength(password) {
      if (password === void 0) { password = ''; }
      loadDictionary();
      // See umreg/registration-app2: password-security.service.ts
      var score = zxcvbn(password).score;
      return zxcvbnScoreToPerCent(score);
  }
  function containsLeadingTrailingWhitespace(value) {
      if (value === void 0) { value = ''; }
      return value.match(/^\s|\s$/) !== null;
  }

  function init$7() {
      registerFormPassword();
  }
  function registerFormPassword() {
      var $forms = $('form[data-password]');
      $forms.each(function (_, item) {
          var $form = $(item);
          var id = $form.data('password') || 'password';
          var idRepeat = $form.data('password-repeat') || 'password-repeat';
          var $password = $form.find("#" + id);
          var $passwordRepeat = $form.find("#" + idRepeat);
          var $passwordLengthMessage = $form.find('[data-password-length-message]');
          var $passwordWeakMessage = $form.find('[data-password-weak-message]');
          var $passwordRepeatMessage = $form.find('[data-password-repeat-message]');
          var $passwordLengthMessageType = $form.find('[data-password-length-message-type]');
          var $passwordWhitespaceMessage = $form.find('[data-password-whitespace-message]');
          var $termsAcceptedCheckbox = $form.find('#terms-accepted');
          var $termsAcceptedMessage = $form.find('[data-terms-accepted-message]');
          var $progressbar = $form.find('[data-progressbar]');
          var toggleProgressbarVisibility = $progressbar.hasClass('progressbar--hidden');
          var $progressbarIndicator = $progressbar.find('.progressbar__indicator');
          var $proceedButton = $form.find('#proceed');
          var state = {
              passwordProgress: 0,
              valueRepeatLength: 0,
              hasMinLength: false,
              isAcceptablePassword: false,
              isStrongPassword: false,
              hideWeakMessage: true,
              arePasswordsEqual: true,
              areTermsAccepted: false,
              forceErrorVisibility: false,
              hideWhitespaceMessage: true,
          };
          function updateView() {
              if (toggleProgressbarVisibility) {
                  $progressbar.toggleClass('progressbar--hidden', !state.hasMinLength);
              }
              var hidePasswordRepeatMessage = state.arePasswordsEqual ||
                  ((state.valueRepeatLength === 0) && !state.forceErrorVisibility);
              $progressbar.toggleClass('progressbar--warning', !state.isStrongPassword);
              $progressbarIndicator.css('width', state.passwordProgress + "%");
              $passwordLengthMessage.toggleClass('form-message--hidden', state.hasMinLength);
              $passwordLengthMessage.toggleClass('form-message--error', state.forceErrorVisibility);
              $passwordLengthMessage.toggleClass('form-message--info', !state.forceErrorVisibility);
              $passwordLengthMessageType.attr('href', (state.forceErrorVisibility) ? '#icon-hint-error' : '#icon-hint-info');
              $passwordWeakMessage.toggleClass('form-message--hidden', state.hideWeakMessage);
              $passwordWhitespaceMessage.toggleClass('form-message--hidden', state.hideWhitespaceMessage);
              $passwordRepeatMessage.toggleClass('form-message--hidden', hidePasswordRepeatMessage);
              var hideTermsAcceptedError = !state.forceErrorVisibility || state.areTermsAccepted;
              $termsAcceptedMessage.toggleClass('form-message--hidden', hideTermsAcceptedError);
          }
          $password.on('keyup', function () {
              var value = $password.val() || '';
              var valueRepeat = $passwordRepeat.val() || '';
              var hasMinLength = value.length >= PASSWORD_MIN_LENGTH;
              var passwordStrength = calculatePasswordStrength(value);
              var isAcceptablePassword = passwordStrength >= PASSWORD_MIN_ACCEPTABLE_SCORE;
              var isStrongPassword = passwordStrength >= PASSWORD_MIN_STRONG_SCORE;
              var hideWeakMessage = !hasMinLength || isAcceptablePassword;
              var arePasswordsEqual = value === valueRepeat;
              var containsWhitespace = containsLeadingTrailingWhitespace(value);
              Object.assign(state, { hasMinLength: hasMinLength, hideWeakMessage: hideWeakMessage, isAcceptablePassword: isAcceptablePassword,
                  isStrongPassword: isStrongPassword, arePasswordsEqual: arePasswordsEqual, passwordProgress: passwordStrength,
                  forceErrorVisibility: false, hideWhitespaceMessage: !containsWhitespace,
              });
              updateView();
              return true;
          });
          $passwordRepeat.on('keyup', function () {
              var value = $password.val() || '';
              var valueRepeat = $passwordRepeat.val() || '';
              var arePasswordsEqual = value === valueRepeat;
              Object.assign(state, { arePasswordsEqual: arePasswordsEqual, valueRepeatLength: valueRepeat.length,
                  forceErrorVisibility: false,
              });
              updateView();
              return true;
          });
          function isSubmitAllowed() {
              return state.hasMinLength && state.isAcceptablePassword && state.arePasswordsEqual &&
                  state.areTermsAccepted && state.hideWhitespaceMessage;
          }
          $proceedButton.on('click', function () {
              Object.assign(state, { areTermsAccepted: $termsAcceptedCheckbox.prop('checked'), forceErrorVisibility: true });
              updateView();
          });
          $form.submit(isSubmitAllowed);
          return true;
      });
  }

  var formPassword = /*#__PURE__*/Object.freeze({
    init: init$7
  });

  // Handle SecurityError for FF on foreign domains. See https://stackoverflow.com/a/23613052
  var hasAccessibleCssRules = function (sheet) {
      try {
          return !!sheet.cssRules;
      }
      catch (e) {
          if (e.name !== 'SecurityError') {
              throw e;
          }
          return false;
      }
  };
  var getAllCssRules = function () {
      var result = [];
      var sheets = document.styleSheets;
      for (var i = 0; i < sheets.length; i += 1) {
          var sheet = sheets[i];
          if (!hasAccessibleCssRules(sheet)) {
              continue;
          }
          var rules = sheet.cssRules;
          for (var j = 0; j < rules.length; j += 1) {
              result.push(rules[j]);
          }
      }
      return result;
  };
  var getAllAnimatedSelectors = function () {
      return getAllCssRules()
          .filter(function (rule) { return !!(rule.style && (rule.style.transition || rule.style.transitionDuration)); })
          .map(function (rule) { return rule.selectorText; });
  };

  // Mark all animation rules with css clases for CI backstop tests
  function init$8() {
      getAllAnimatedSelectors().forEach(function (selector) { return $(selector).animated(); });
  }

  var markAnimations = /*#__PURE__*/Object.freeze({
    init: init$8
  });

  var SHOW_ICON = '#icon-password-show';
  var HIDE_ICON = '#icon-password-hide';
  function init$9() {
      registerPasswordEyeInitiators();
  }
  function registerPasswordEyeInitiators() {
      var $initiators = $('.password-eye');
      var pwFields = [];
      $initiators.each(function (_, item) {
          var $initiator = $(item);
          var $input = $initiator.find('.password-eye__input');
          var $button = $initiator.find('.password-eye__button');
          var buttonShowTitle = $button.attr('title');
          var buttonHideTitle = $button.data('hide-title');
          if (!$input.length) {
              return true;
          }
          pwFields.push($input.get(0));
          var showAlwaysEye = $button.hasClass('password-eye__button--visible');
          $input.on('input', function () {
              var hasValue = !!$input.val().length;
              $button.toggleClass('password-eye__button--visible', hasValue || showAlwaysEye);
              return true;
          });
          $button.on('click', function () {
              var type = $input.attr('type') === 'password' ? 'text' : 'password';
              var title = type === 'text' ? buttonHideTitle : buttonShowTitle;
              var icon = type === 'text' ? HIDE_ICON : SHOW_ICON;
              var $svg = $button.find('svg > use');
              $input.attr('type', type);
              $button.attr('title', title);
              $svg.attr('xlink:href', icon);
              return true;
          });
          return true;
      });
      function resetPasswordType() {
          pwFields.forEach(function (item) {
              $(item).attr('type', 'password');
          });
          return true;
      }
      $('form').on('submit', resetPasswordType);
  }

  var passwordEye = /*#__PURE__*/Object.freeze({
    init: init$9
  });

  function init$a() {
      tooltip();
  }
  function tooltip() {
      var $initiators = $('[data-tooltip]');
      $initiators.each(function (_, item) {
          var $initiator = $(item);
          var tooltipText = $initiator.data('tooltip');
          if (!tooltipText) {
              return true;
          }
          var tooltipCloseSelector = $initiator.data('tooltip-close-selector');
          var html = "<span class=\"tooltip\">" + tooltipText.replace(/\\n/g, '<br />') + "</span>";
          var $tooltip = null;
          function showTooltip() {
              $initiator.append(html);
              $tooltip = $initiator.find('.tooltip');
              $tooltip.css('top', $initiator.height() + 5);
          }
          function hideTooltip() {
              if ($tooltip !== null) {
                  $tooltip.css('opacity', 0);
                  setTimeout(function () {
                      if ($tooltip !== null) {
                          $tooltip.remove();
                          $tooltip = null;
                      }
                  }, DEFAULT_ANIMATION_TIME);
              }
              return true;
          }
          // closes the tooltip immediatly without any effect
          function closeTooltip() {
              if ($tooltip !== null) {
                  $tooltip.remove();
                  $tooltip = null;
              }
          }
          $initiator.on('click', function () {
              if ($tooltip === null) {
                  showTooltip();
              }
              else {
                  hideTooltip();
              }
              return true;
          });
          if (tooltipCloseSelector) {
              $(tooltipCloseSelector).on('click', closeTooltip);
          }
          return true;
      });
  }

  var tooltip$1 = /*#__PURE__*/Object.freeze({
    init: init$a
  });

  var permissionLayerIframeSelector = '[data-permission-layer]';
  var headerSelector = 'header';
  function init$b() {
      if ($(permissionLayerIframeSelector).length) {
          registerStickyFooter();
      }
  }
  function registerStickyFooter() {
      var $iframe = $(permissionLayerIframeSelector);
      var contentWindow = $iframe.get(0).contentWindow;
      var $header = $(headerSelector);
      var trustedOrigins = getTrustedOrigins($iframe);
      var running = false;
      var scrollEnd = undefined;
      var scrollTopLoopRunning = false;
      $(window).on('message', function (evt) {
          var messageEvent = evt;
          if (trustedOrigins.indexOf(messageEvent.origin) < 0) {
              return true;
          }
          if (messageEvent.data.height) {
              setHeight(+messageEvent.data.height);
          }
          return true;
      });
      function getTrustedOrigins($iframe) {
          var iframeSrc = $iframe.attr('src');
          var anchor = $('<a>', { href: iframeSrc }).get(0);
          return [location.protocol + "//" + location.host, anchor.protocol + "//" + anchor.host];
      }
      function setHeight(height) {
          if (!running) {
              running = true;
              // as recommended by MDN the DOM update is throttled:
              // https://developer.mozilla.org/en-US/docs/Web/Events/resize
              requestAnimationFrame(function () {
                  running = false;
                  $iframe.height(height);
                  startUpdateScrollTopLoop();
              });
          }
      }
      function startUpdateScrollTopLoop() {
          if (!scrollTopLoopRunning) {
              scrollTopLoopRunning = true;
              requestAnimationFrame(updateScrollPosition);
          }
      }
      function updateScrollPosition() {
          var scrollTop = $(window).scrollTop() - $header.height();
          var windowHeight = $(window).height();
          var currentScrollEnd = scrollTop + windowHeight;
          if (scrollEnd !== currentScrollEnd && contentWindow) {
              scrollEnd = currentScrollEnd;
              contentWindow.postMessage({ scrollTop: scrollTop, windowHeight: windowHeight }, trustedOrigins[1]);
          }
          requestAnimationFrame(updateScrollPosition);
      }
  }

  var permissionHost = /*#__PURE__*/Object.freeze({
    init: init$b
  });

  var height;
  function init$c() {
      var redirectUrl = $('[data-permission-redirect]').attr('data-permission-redirect');
      if (redirectUrl && parent !== window) {
          updateHeight();
          var match = redirectUrl.match(/\?(.+&)?delay=(\d+)(&.+)?$/);
          var delay = match ? +match[2] : 0;
          setTimeout(function () { return parent.location.href = redirectUrl; }, delay);
      }
  }
  function updateHeight() {
      var currentHeight = $('html').height();
      if (height !== currentHeight) {
          height = currentHeight;
          sendHeight(height);
      }
      requestAnimationFrame$1(updateHeight);
  }
  function sendHeight(height) {
      var parent = window.parent;
      if (parent) {
          var trustedOrigin = location.protocol + "//" + location.host;
          parent.postMessage({ height: height }, trustedOrigin);
      }
  }

  var permissionDone = /*#__PURE__*/Object.freeze({
    init: init$c
  });

  var getMissingFeatures = function () {
      var missingFeatures = [];
      if (typeof Modernizr !== 'undefined') {
          for (var feature in Modernizr) {
              if (typeof Modernizr[feature] === 'boolean' && Modernizr[feature] === false) {
                  missingFeatures.push(feature);
              }
          }
      }
      return missingFeatures;
  };
  var isFeatureMissing = function (feature) {
      return getMissingFeatures().indexOf(feature) >= 0;
  };

  /*
    Parses the noscript content and redirect to given URL

    ```
    <noscript>
      <meta http-equiv="refresh" content="0; url=./nojs.html">
    </noscript>
    ```
  */
  var redirectToNoScript = function () {
      var $noScript = $('head noscript');
      var noScriptContent = $noScript.html();
      var redirectContent = $(noScriptContent).attr('content');
      var urlPos = redirectContent.toLowerCase().indexOf('url=');
      if (urlPos >= 0) {
          location.href = redirectContent.substr(urlPos + 4);
      }
  };
  function init$d() {
      if (isFeatureMissing('cookies')) {
          redirectToNoScript();
      }
  }

  var redirectNoCookie = /*#__PURE__*/Object.freeze({
    init: init$d
  });

  function init$e() {
      slideshow();
  }
  function slideshow() {
      $('.slideshow').each(function (_, element) {
          var $container = $(element);
          var $resizeContainer = $("#" + $container.data('slideshow-resize'));
          var isActiveClass = $container.data('slideshow-active-class');
          var $slideContainer = $container.find('.slideshow__slide-container');
          var $slides = $container.find('.slideshow__slide');
          var $dots = $container.find('.dots .dots__dot');
          var slideEffect = function ($currentSlide, $nextSlide, direction) {
              var currentEffectClass = direction === 'left' ? 'slideshow__slide--out-right' : 'slideshow__slide--out-left';
              var nextEffectClass = direction === 'left' ? 'slideshow__slide--in-left' : 'slideshow__slide--in-right';
              $currentSlide.removeClass('slideshow__slide--active').addClass(currentEffectClass)
                  .one('transitionend', function () { return $currentSlide.removeClass(currentEffectClass); });
              $nextSlide.addClass('slideshow__slide--active').addClass(nextEffectClass)
                  .one('transitionend', function () { return $nextSlide.removeClass(nextEffectClass); });
          };
          var showSlide = function (index, $direction) {
              if ($direction === void 0) { $direction = 'auto'; }
              var currentIndex = $dots.filter('.dots__dot--active').index();
              var $currentSlide = $($slides.get(currentIndex));
              var $nextSlide = $($slides.get(index));
              var slideHeightDiff = $nextSlide.height() - $currentSlide.height();
              // Skip action to same index or on running animation
              if (currentIndex === index ||
                  $currentSlide.hasClass('slideshow__slide--in-right') ||
                  $currentSlide.hasClass('slideshow__slide--in-left')) {
                  return;
              }
              var effect = $direction;
              if (effect === 'auto') {
                  effect = currentIndex < index ? 'right' : 'left';
              }
              slideEffect($currentSlide, $nextSlide, effect);
              $dots.removeClass('dots__dot--active');
              $($dots.get(index)).addClass('dots__dot--active');
              $slideContainer.resizeHeight($nextSlide.height(), DEFAULT_ANIMATION_TIME);
              // Add height diff since new height is available after the animation
              $resizeContainer.resizeHeight($resizeContainer.height() + slideHeightDiff, DEFAULT_ANIMATION_TIME);
          };
          $dots.on('click', function (e) {
              var index = $(e.currentTarget).index();
              showSlide(index);
          });
          $container.find('[data-slideshow-close]').on('click', function (e) {
              $container.hide();
              return true;
          });
          $container.touch().on('swipeLeft', function () {
              var index = $dots.filter('.dots__dot--active').index();
              showSlide((index + 1) % $dots.length, 'right');
          }).on('swipeRight', function () {
              var index = $dots.filter('.dots__dot--active').index();
              showSlide((index - 1) % $dots.length, 'left');
          });
          $container.on('toggle-group:toggle', function () {
              $slideContainer.height($slides.filter('.slideshow__slide--active').height());
          });
          $slideContainer.height($slides.filter('.slideshow__slide--active').height());
          var resizeSlideContainer = function () {
              if (!isActive()) {
                  return true;
              }
              var $currentSlide = $slides.filter('.slideshow__slide--active');
              $slideContainer.resizeHeight($currentSlide.height(), DEFAULT_ANIMATION_TIME, resizeResizeContainer);
              return true;
          };
          var isActive = function () {
              return !isActiveClass || $container.hasClass(isActiveClass);
          };
          var resizeResizeContainer = function () {
              $resizeContainer.height($container.height());
          };
          // handle window resizes
          $(window).on('resize', throttle(resizeSlideContainer, 150));
          return true;
      });
  }

  var slideshow$1 = /*#__PURE__*/Object.freeze({
    init: init$e
  });

  function init$f() {
      slider();
  }
  function slider() {
      $('[data-slide-in]').on('click', function (e) {
          var id = $(e.currentTarget).data('slide-in');
          var $slider = $("[data-slider=\"" + id + "\"]");
          var $background = $slider.find('.slider__background');
          var $overlay = $slider.find('.slider__overlay');
          $overlay.addClass('slider__overlay--show').animated();
          $background.addClass('slider__background--hidden').animated();
          // Delay container resizing to fix small view
          setTimeout(function () {
              $slider.resizeHeight($overlay.height(), SLIDER_ANIMATION_TIME);
          }, 0);
          return true;
      });
      $('[data-slide-out]').on('click', function (e) {
          var id = $(e.currentTarget).data('slide-out');
          var $slider = $("[data-slider=\"" + id + "\"]");
          var $background = $slider.find('.slider__background');
          var $overlay = $slider.find('.slider__overlay');
          $overlay.removeClass('slider__overlay--show').animated();
          $background.removeClass('slider__background--hidden').animated();
          $slider.resizeHeight($background.height(), SLIDER_ANIMATION_TIME, undefined, function () {
              $slider.css({ height: null });
          });
          return true;
      });
  }

  var slider$1 = /*#__PURE__*/Object.freeze({
    init: init$f
  });

  function init$g() {
      registerToggleInitiators();
  }
  function registerToggleInitiators() {
      var attributeName = 'data-toggle';
      var $initiators = $("[" + attributeName + "]");
      $initiators.each(function (index, item) {
          var $initiator = $(item);
          var className = $initiator.attr(attributeName);
          if (className) {
              $initiator.on('click', function () {
                  $initiator.toggleClass(className);
                  return true;
              });
          }
          return true;
      });
  }

  var toggle = /*#__PURE__*/Object.freeze({
    init: init$g
  });

  function init$h() {
      registerToggleGroup();
  }
  function registerToggleGroup() {
      $('[data-toggle-group-button]').on('click', function (e) {
          var $element = $(e.currentTarget);
          var groupName = $element.data('toggle-group') || $element.data('toggle-group-button');
          if (groupName) {
              var $toggleGroup = $("[data-toggle-group='" + groupName + "']");
              // Toggle display and trigger event for other components
              $toggleGroup
                  .toggle()
                  .trigger('toggle-group:toggle');
          }
      });
  }

  var toggleGroup = /*#__PURE__*/Object.freeze({
    init: init$h
  });

  function init$i() {
      verificationCode();
  }
  function verificationCode() {
      var KEY_BACKSPACE = 8;
      var KEY_TAB = 9;
      var KEY_LEFT = 37;
      var KEY_RIGHT = 39;
      $('.verification-code').each(function (_, item) {
          var $item = $(item);
          var $inputs = $item.find('.input');
          $inputs.on('click', function (e) {
              var input = (e.currentTarget);
              input.setSelectionRange(0, input.value.length);
              return true;
          });
          // Counter to drop concurrent keys events. These occurs on very fast keyboard input
          var concurrentKeyDownCounter = 0;
          $inputs.on('keydown', function (e) {
              concurrentKeyDownCounter += 1;
              if (concurrentKeyDownCounter > 1) {
                  return false;
              }
              var $input = $(e.currentTarget);
              $input.data('prevValue', $input.val());
              return true;
          });
          $inputs.on('keyup', function (e) {
              concurrentKeyDownCounter -= 1;
              if (concurrentKeyDownCounter > 0) {
                  return false;
              }
              var keyCode = e.keyCode;
              var $input = $(e.currentTarget);
              var prevValue = $input.data('prevValue');
              var index = $inputs.index($input.get(0));
              var nextIndex = index + 1;
              if (keyCode === KEY_TAB || keyCode === KEY_LEFT || keyCode === KEY_RIGHT) {
                  return false;
              }
              if (keyCode === KEY_BACKSPACE) {
                  if (prevValue.length) {
                      return true;
                  }
                  nextIndex = index - 1;
              }
              if (nextIndex >= 0 && nextIndex < $inputs.length) {
                  var nextInput = ($inputs.get(nextIndex));
                  nextInput.focus();
                  nextInput.setSelectionRange(0, nextInput.value.length);
              }
              return true;
          });
          return true;
      });
  }

  var verificationCode$1 = /*#__PURE__*/Object.freeze({
    init: init$i
  });

  function init$j() {
      registerDebouncedSubmit();
  }
  function registerDebouncedSubmit() {
      var $forms = $('form');
      $forms.each(function (_, item) {
          var form = $(item);
          form.on('submit', function (event) {
              if (!event.defaultPrevented) {
                  var submitButton = form.find('button[type="submit"]');
                  // cannot set disabled attribute because this will stop name/value attributes to be propagated to the request
                  if (submitButton.data('disabled')) {
                      return false;
                  }
                  submitButton.data('disabled', 'true');
              }
          });
          return true;
      });
  }

  var submitDebounce = /*#__PURE__*/Object.freeze({
    init: init$j
  });

  $(document).ready(function () {
      [
          accordion,
          checkbox,
          collapsible,
          details,
          dialog,
          infoBox,
          invalidBrowser,
          formPassword,
          markAnimations,
          passwordEye,
          permissionHost,
          permissionDone,
          redirectNoCookie,
          slideshow$1,
          slider$1,
          toggle,
          tooltip$1,
          toggleGroup,
          verificationCode$1,
          submitDebounce,
      ].forEach(function (module, index) {
          try {
              module.init();
          }
          catch (e) {
              console.log("Initialization of module " + index + " failed: " + e);
          }
      });
  });

}());

//# sourceMappingURL=script.js.map
